import { render, staticRenderFns } from "./GoogleMyBusinessRatingsByStars.vue?vue&type=template&id=2148e490&"
import script from "./GoogleMyBusinessRatingsByStars.vue?vue&type=script&lang=js&"
export * from "./GoogleMyBusinessRatingsByStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports